export {getDefaultAttachments} from '@Components/ai-prompt-box/libraries/ai-prompt-box-attachment.library';
import {aiPromptBoxActions} from '@Components/ai-prompt-box/ai-prompt-box.reducer';
import {PromptBoxState} from '@Components/ai-prompt-box/ai-prompt-box.types';
import {nextPromptBoxKey} from '@Components/ai-prompt-box/libraries/ai-prompt-box-key.library';

export function sendPrompt(promptBoxId: string, text: string): void {
  window.PMW.redux.store.dispatch(
    aiPromptBoxActions.updateAiPromptBox({
      id: promptBoxId,
      value: {prompt: text, promptBoxState: PromptBoxState.ACTIVE, focusKey: nextPromptBoxKey(), submitKey: nextPromptBoxKey()},
    })
  );
}

export function focusPromptBox(promptBoxId: string): void {
  window.PMW.redux.store.dispatch(
    aiPromptBoxActions.updateAiPromptBox({
      id: promptBoxId,
      value: {promptBoxState: PromptBoxState.ACTIVE, focusKey: nextPromptBoxKey()},
    })
  );
}
